/* GENERATED by scripts/gen-data.mjs — subject taxonomy (from s1.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { TopicKey } from '../types';

export const TOPIC_ORDER: TopicKey[] = [
  "foundations",
  "models",
  "scale",
  "retrieval",
  "events",
  "architecture",
  "tooling",
  "safety",
  "evaluation",
  "data",
  "production",
  "cost",
  "learning"
];
